import axios from 'axios';

import {config} from '../../Config';
import {SET_SESSION_TIMEOUT, VERIFICATION_START} from "../../Redux/Actions/Types";
import {
    applyAuthResponsePayload,
    getAuthToken,
    isTwoFactorRequired,
} from './BaseServiceState';

const sbAxios = axios.create({
    withCredentials: true,
    timeout: 120000,
    headers: {
        'Content-Type': 'application/json',
    },
});

sbAxios.interceptors.request.use((requestConfig) => {
    requestConfig.headers ??= {};
    const existingHeader = requestConfig.headers['Authorization'] ?? requestConfig.headers['authorization'];
    if(!existingHeader) {
        const token = getAuthToken();
        if(token) {
            requestConfig.headers['Authorization'] = token;
        }
    }

    return requestConfig;
});

sbAxios.interceptors.response.use(
    (response) => {
        applyAuthResponsePayload(response?.data);
        return response;
    },
    (error) => {
        const status = error?.response?.status;

        if(status === 401) {
            return Promise.reject(handleUnauthorized(error));
        }

        if(status === 403) {
            const handled = handleForbidden(error);
            if(handled) {
                return Promise.reject(handled);
            }
        }

        if (error?.response?.data?.message) {
            error.message = error.response.data.message;
        }
        return Promise.reject(error);
    }
);

function handleUnauthorized(error) {
    config.getStore().dispatch({type: SET_SESSION_TIMEOUT, value: true});

    const xhr = error?.response ?? error?.request;
    const result = error?.response?.data;

    return {
        message: result?.message ?? xhr?.statusText ?? 'Session timeout.',
        data: { success: false, sessionTimeout: true },
        xhr,
    };
}

function handleForbidden(error) {
    if(isTwoFactorRequired()) {
        config.getStore().dispatch({type: VERIFICATION_START });
        config.getStore().dispatch({type: SET_SESSION_TIMEOUT, value: true});

        const xhr = error?.response ?? error?.request;
        const result = error?.response?.data;

        return {
            message: result?.message ?? xhr?.statusText ?? 'Two-factor authentication is required.',
            data: { success: false, sessionTimeout: true },
            xhr,
        };
    }

    return null;
}

export default sbAxios;
